import { AxiosRequestConfig } from 'axios'
import qs from 'qs'
import { ArpeggiSupportedChain } from '../../../types'

export const axiosConfig: AxiosRequestConfig = {
  baseURL: '',
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'brackets' })
}

/**
 * These are the prefixes for the endpoints specified here:
 * https://docs.alchemy.com/docs/how-to-add-alchemy-rpc-endpoints-to-metamask
 */
export const PROD_NETWORKS: Record<ArpeggiSupportedChain, string> = {
  ethereum: 'eth-mainnet',
  polygon: 'polygon-mainnet',
  optimism: 'opt-mainnet'
}

export const DEV_NETWORKS: Record<ArpeggiSupportedChain, string> = {
  ethereum: 'eth-goerli',
  polygon: 'polygon-mumbai',
  optimism: 'opt-goerli'
}
